import useGetClients from './useGetClients'

export default function useGetResources() {
  useGetClients()
}
